import React from 'react';
import IconContainer from '../IconContainer';
import PaymentLogo from 'scy/PaymentLogo';

export default function Icon({ paymentMethod = {} }) {
  return (
    <IconContainer>
      <PaymentLogo brand={paymentMethod.brand} />
    </IconContainer>
  );
}
